module.exports = __webpack_public_path__ + "static/media/Mountain2.960ee443.png";


//////////////////
// WEBPACK FOOTER
// ./src/Mountain2.png
// module id = 37
// module chunks = 0